const titleWithElementName = (title, element) => {
  if (element === null) {
    return title
  } else {
    // 時系列の進路の移り変わり設問のとき
    // チャートタイトルが
    // 希望進路の移り変わり（進路の移り変わり（2022年））
    // ではなく
    // 希望進路の移り変わり（2022年）
    // となるようにする
    if (element.name.indexOf("進路の移り変わり（") !== -1) {
      const yearTextMatch = element.name.match(/（(.+)）/)
      if (yearTextMatch === null) {
        return title
      } else {
        return `${title}（${yearTextMatch[1]}）`
      }
    }
    return `${title}（${element.name}）`
  }
}

function ChartTitle({ title, element }) {
  return (
    <div className="pb-2">
      <div className="bg-main-blue w-1 sm:w-1.5 h-6 sm:h-8 inline-block"></div>
      <div className="pl-3 sm:pl-5 text-lg sm:text-xl md:text-2xl font-semibold text-main-blue inline-block align-top">
        {titleWithElementName(title, element)}
      </div>
    </div>
  );
}

export default ChartTitle;
